'use strict';

/**
 * @puffin-core/email-address — the ONE email-address rule (L-R7CLOSE row 43). CJS entry; the ESM
 * mirror (`lib/esm/index.js`) is generated from it by `@puffin-tooling/esm-build`.
 *
 * @module @puffin-core/email-address
 */

const { EMAIL_ADDRESS_LIMITS, isEmailAddress, joiEmailAddress } = require('./emailAddress');
const { normalizeEmail } = require('./normalizeEmail');

module.exports = { EMAIL_ADDRESS_LIMITS, isEmailAddress, joiEmailAddress, normalizeEmail };
